import React from 'react';
import { MyGames } from 'src/sections';

function MyGamesPage(props) {
  return <MyGames />;
}

export default MyGamesPage;
